<template>
  <div id="app">
    <img class="logo" alt="PitchPrint logo" src="./assets/logo-pp.png">
    <span class="plus"><span class="plus-inner"><span>+</span></span></span>
    <img alt="Vue logo" src="./assets/logo.png">
    <h1>Welcome to PitchPrint VueJS Demo App</h1>
	<p>Click the customize button to start editing a design.</p>
	<PitchPrint class="push_down" apiKey="f80b84b4eb5cc81a140cb90f52e824f6" designId="1d5e8885c7defb4cb3144dbf344a9da5" langCode="en" display="modal" />
	<div class="preview"></div>
  </div>
</template>

<script>

import PitchPrint from 'vue-pitchprint'

export default {
  name: 'App',
  components: {
	PitchPrint,
  },
  mounted() {
	this.$root.$on('pitchprint-project-saved', this.showPreview);
  },
  methods: {
	showPreview(data) {
		document.querySelector('.preview').innerHTML = `<img src="${data.previews[0]}"/>`;
	}
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.logo {
	width: 187px;
}
.plus {
	vertical-align: bottom;
    height: 193px;
    display: inline-block;
    font-size: 6rem;
    font-weight: bold;
}
.plus-inner {
	display: flex;
    height: 100%;
    align-items: center;
}
.preview {
	margin: auto;
}
.preview img {
	width: 250px;
}
.push_down {
	margin-bottom: 10px;
}
</style>
